// extracted by mini-css-extract-plugin
module.exports = {"GreenBox":"Submit_GreenBox__zGlou","sucessText":"Submit_sucessText__n1m9Q","sucessSubText":"Submit_sucessSubText__HEJi_"};